import { render, staticRenderFns } from "./TrainingPlanStopwatch.vue?vue&type=template&id=635cd639&scoped=true&"
import script from "./TrainingPlanStopwatch.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanStopwatch.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanStopwatch.vue?vue&type=style&index=0&id=635cd639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cd639",
  null
  
)

export default component.exports